<span
	[ngClass]="{
		datos_cuenta_trans: item.isAccount,
		datos_trans_left: item.textAlign === 'left',
		datos_trans_right: item.textAlign === 'right'
	}"
	[class]="getClass()"
>
	<h5>{{ item.title }}</h5>
	<p [innerHtml]="item.subTitle"></p>
</span>
